<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-8">
        <Heading title="Social" subTitle="We use following links to show social media widgets on AMP." />
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6 mb-0">Accounts</h2>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <div class="form-group">
              <label for="sctwitter">Twitter Username</label>
              <input type="text" class="form-control" id="sctwitter" v-model="social__twitter">
              <small class="form-text text-muted">Only username without @</small>
            </div>
            <div class="form-group">
              <label for="scfacebook">Facebook Page Link</label>
              <input type="text" class="form-control" id="scfacebook" v-model="social__facebook">
              <small class="form-text text-muted">Complete Facebook page link.</small>
            </div>
            <div class="form-group">
              <label for="scinsta">Instagram Username</label>
              <input type="text" class="form-control" id="scinsta" v-model="social__instagram">
              <small class="form-text text-muted">Only username.</small>
            </div>
            <div class="form-group">
              <label for="scsnapchat">Snapchat Username</label>
              <input type="text" class="form-control" id="scsnapchat" v-model="social__snapchat">
              <small class="form-text text-muted">Only username.</small>
            </div>
            <div class="form-group">
              <label for="scmedium">Medium Account Link</label>
              <input type="text" class="form-control" id="scmedium" v-model="social__medium">
              <small class="form-text text-muted">Complete Medium account link.</small>
            </div>
            <div class="form-group mb-0">
              <label for="scpinterest">Pinterest Page Link</label>
              <input type="text" class="form-control" id="scpinterest" v-model="social__pinterest">
              <small class="form-text text-muted">Complete Pinterest page link.</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <SaveButton :hasChanged="hasChanged" @click="saveMaster" bar discard class="text-right" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import watchForChange from '@/mixins/watchForChange'
import mapMultiComputed from '@/mixins/mapMultiComputed'

export default {
  mixins: [
    watchForChange(),
    mapMultiComputed('settings', [
      'social.twitter',
      'social.facebook',
      'social.instagram',
      'social.snapchat',
      'social.medium',
      'social.pinterest'
    ])
  ],
  methods: mapActions([ 'saveMaster' ])
}
</script>
